import request from "@/router/axios";

// 维修工单 - 列表查询
export const getList = (params) => {
  return request({
    url: "/api/produce/work-order/select/page",
    method: "post",
    params: params,
  });
};

// 维修工单 - 新增
export const add = (row) => {
  return request({
    url: "/api/produce/work-order/insert",
    method: "post",
    data: row,
  });
};

// 维修工单 - 更新
export const update = (row) => {
  return request({
    url: "/api/produce/work-order/update",
    method: "post",
    data: row,
  });
};

// 维修工单 - 删除
export const remove = (id) => {
  return request({
    url: "/api/produce/work-order/delete",
    method: "post",
    params: { ids: id },
  });
};

// 维修工单 - 详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/work-order/select/id",
    method: "get",
    params: { id },
  });
};

// 维修工单 - 更新状态
export const updateStatus = (row) => {
  return request({
    url: "/api/produce/work-order/update",
    method: "post",
    data: row,
  });
};

// 通用上传（复用已有OSS附件上传接口）
export const uploadEndpoint = "/api/blade-resource/oss/endpoint/put-file-attach";
